const parseTimeoutMinutes = (value: string | undefined): number | null => {
  if (!value) return null;
  const parsed = Number(value);
  if (!Number.isFinite(parsed) || parsed <= 0) return null;
  return parsed;
};

const toMs = (minutes: number) => Math.round(minutes * 60 * 1000);

export const DOZENT_INACTIVITY_TIMEOUT_MS = toMs(
  parseTimeoutMinutes(
    import.meta.env.VITE_DOZENT_INACTIVITY_TIMEOUT_MINUTES as
      | string
      | undefined,
  ) ?? 30,
);

export const ADMIN_INACTIVITY_TIMEOUT_MS = toMs(
  parseTimeoutMinutes(
    import.meta.env.VITE_ADMIN_INACTIVITY_TIMEOUT_MINUTES as string | undefined,
  ) ?? 15,
);
